<template>
  <v-layout
    row
    align-content-space-between
    align-center
    class="shift-item"
    :class="{ 'grey lighten-2': this.stripe }"
    pa-2
  >
    <v-flex xs4>
      <v-layout row align-content-start align-center>
        <v-flex class="shift-details">
          <h2 class="font-weight-regular">
            {{ itemData.startDatetime | moment("dddd, MMMM D") }}
          </h2>
          <h2>
            <router-link
              :to="{ name: 'shiftDetail', params: { shiftId: itemData.id } }"
            >
              {{ itemData.shiftRole }}
            </router-link>
          </h2>
          <h2 class="subtle font-weight-regular">
            {{ itemData.startDatetime | moment("h:mma") }} -
            {{ itemData.endDatetime | moment("h:mma") }}
          </h2>
          <h2 class="subtle font-weight-regular">
            <router-link
              :to="{
                name: 'worksiteShow',
                params: { worksiteId: itemData.worksiteId }
              }"
            >
              {{ itemData.location }}
            </router-link>
          </h2>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex mx-4 xs5>
      <v-flex v-if="admin" mb-2>
        <v-btn color="primary" disabled>
          <v-icon left> create </v-icon>
          Edit
        </v-btn>
        <v-btn color="error" disabled>
          <v-icon left> remove_circle </v-icon>
          Remove
        </v-btn>
      </v-flex>
      <v-flex v-else mb-2>
        <v-btn class="white--text" color="grey darken-2" disabled>
          <v-icon left> compare_arrows </v-icon>
          Trade
        </v-btn>
        <v-btn color="success" disabled>
          <v-icon left> chat_bubble </v-icon>
          Contact
        </v-btn>
      </v-flex>

      <v-flex>
        <v-layout row justify-left>
          <v-tooltip bottom :disabled="!itemData.hasDirections">
            <v-icon
              medium
              slot="activator"
              :color="itemData.hasDirections ? 'blue' : 'grey lighten-2'"
              class="shift-details-icon"
            >
              location_on
            </v-icon>
            <span>Directions Available</span>
          </v-tooltip>

          <v-tooltip bottom :disabled="!itemData.hasTravelBonus">
            <v-icon
              medium
              slot="activator"
              :color="
                itemData.hasTravelBonus ? 'grey darken-2' : 'grey lighten-2'
              "
              class="shift-details-icon"
            >
              directions_car
            </v-icon>
            <span>{{ itemData.travelBonusAmount }}</span>
          </v-tooltip>

          <v-tooltip bottom :disabled="!itemData.hasCallInBonus">
            <v-icon
              medium
              slot="activator"
              :color="
                itemData.hasCallInBonus ? 'grey darken-2' : 'grey lighten-2'
              "
              class="shift-details-icon"
            >
              phone
            </v-icon>
            <span>{{ itemData.callInBonusAmount }}</span>
          </v-tooltip>

          <v-tooltip bottom :disabled="!itemData.hasStraightBonus">
            <v-icon
              medium
              slot="activator"
              :color="
                itemData.hasStraightBonus ? 'grey darken-2' : 'grey lighten-2'
              "
              class="shift-details-icon"
            >
              local_atm
            </v-icon>
            <span>{{ itemData.straightBonusAmount }}</span>
          </v-tooltip>
        </v-layout>
      </v-flex>
    </v-flex>

    <v-flex xs3>
      <div class="subtle">
        <p class="body-1">
          <span class="font-weight-bold text-uppercase">Shift Details: </span
          >{{ itemData.details }}
        </p>
      </div>
      <div class="subtle">
        <p class="body-1">
          <span class="font-weight-bold text-uppercase">Bonus: </span>
          {{
            itemData.hasStraightBonus
              ? `Client Added ${itemData.straightBonusAmount}.`
              : ""
          }}
          {{
            itemData.hasTravelBonus
              ? `Travel ${itemData.travelBonusAmount}.`
              : ""
          }}
          {{
            itemData.hasCallInBonus
              ? `Call In ${itemData.callInBonusAmount}.`
              : ""
          }}
        </p>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    stripe: Boolean,
    itemData: Object,
    admin: Boolean
  },
  computed: {},
  methods: {},
  data: function() {
    return {};
  }
};
</script>

<style scoped>
.shift-item {
  min-width: 350px;
}

.icon {
  display: inline-block;
}
.shift-details-icon {
  cursor: default;
}

.shift-details {
  display: inline-block;
}
</style>
